import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import MainDrawer from "./MainDrawer";
import Sidebar from "../../Layout/Sidebar";

function MenuDrawer({ isOpen, toggleDrawer }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <MainDrawer isOpen={isOpen} toggleDrawer={toggleDrawer}>
          <motion.div
            initial={{ x: "-100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{
              duration: 0.35,
              ease: [0.25, 1, 0.5, 1], // smooth Apple-style
            }}
            className="h-full w-full bg-navy"
          >
            <Sidebar />
          </motion.div>
        </MainDrawer>
      )}
    </AnimatePresence>
  );
}

export default MenuDrawer;
